import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Image1 from '../images/1.jpg';
import Image2 from '../images/2.jpg';
import Image3 from '../images/3.jpg';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const images = [Image1, Image2, Image3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);
  

  return (
    <div style={{ backgroundColor: '#EFEFEF', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
      <div className="costar-container" style={{ maxWidth: '100%', textAlign: 'center' }}>
        {/* Main Heading */}
        <h1 style={{
          fontFamily: 'GT-America-Mono, monospace',
          fontSize: 'clamp(2.5rem, 8vw, 4rem)',
          fontWeight: 'normal',
          color: '#000000',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem',
          textTransform: 'uppercase'
        }}>
          GEISTS
        </h1>

        {/* Subtitle */}
        <p style={{
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          fontSize: 'clamp(1rem, 3vw, 1.5rem)',
          color: '#4A4A4A',
          marginBottom: '2rem',
          letterSpacing: '0.01em',
          fontWeight: '400'
        }}>
          manifest with friends
        </p>

        {/* Buttons */}
        <div style={{ marginBottom: '3rem', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
          <button
            onClick={() => window.location.href = "https://apps.apple.com/us/app/geists-talk-to-anyone/id6737850836"}
            style={{
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              fontSize: '1rem',
              textTransform: 'none',
              letterSpacing: '-0.01em',
              fontWeight: '600',
              backgroundColor: '#000000',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              padding: '16px 48px',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
              minWidth: '280px'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}
          >
            Download
          </button>

          {/* Quiz Button */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => navigate('/quiz')}
              style={{
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                fontSize: '1rem',
                textTransform: 'none',
                letterSpacing: '-0.01em',
                fontWeight: '600',
                backgroundColor: 'transparent',
                color: '#000000',
                border: '2px solid #000000',
                borderRadius: '8px',
                padding: '16px 48px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                minWidth: '280px'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#000000';
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#000000';
              }}
            >
              Take the Quiz
            </button>
            <p style={{
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
              fontSize: '0.9rem',
              color: '#666666',
              marginTop: '0.5rem',
              letterSpacing: '0',
              fontWeight: '400',
              lineHeight: '1.4'
            }}>
              Find out who you are meant to be
            </p>
          </div>
        </div>

        {/* iPhone Mockup */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          marginBottom: '3rem',
          position: 'relative'
        }}>
          <div style={{ position: 'relative', maxWidth: '400px', width: '100%' }}>
            <img
              src={images[currentImageIndex]}
              alt="Geists app interface"
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '12px',
                transition: 'opacity 0.5s ease-in-out'
              }}
            />
            {/* Carousel Dots */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '8px',
              marginTop: '20px'
            }}>
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  style={{
                    width: index === currentImageIndex ? '24px' : '8px',
                    height: '8px',
                    borderRadius: '4px',
                    border: 'none',
                    backgroundColor: index === currentImageIndex ? '#000000' : '#666666',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    padding: 0
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer style={{
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          fontSize: '0.85rem',
          color: '#4A4A4A',
          textAlign: 'center',
          marginTop: '4rem',
          paddingTop: '2rem',
          borderTop: '1px solid #A0A0A0',
          fontWeight: '400'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <a 
              href="mailto:support@geists.app" 
              style={{ 
                color: '#000000', 
                textDecoration: 'none',
                marginRight: '1.5rem',
                fontWeight: '500'
              }}
            >
              contact
            </a>
            <a 
              href="/privacy-policy" 
              style={{ 
                color: '#000000', 
                textDecoration: 'none',
                marginRight: '1.5rem',
                fontWeight: '500'
              }}
            >
              privacy
            </a>
            <a 
              href="/terms-and-conditions" 
              style={{ 
                color: '#000000', 
                textDecoration: 'none',
                fontWeight: '500'
              }}
            >
              terms
            </a>
          </div>
          <p style={{ margin: '0.5rem 0', color: '#666666', fontWeight: '400' }}>Geists, LLC</p>
          <p style={{ margin: '0.5rem 0', color: '#666666', fontWeight: '400' }}>8 The Green #8416, Dover, DE 19901</p>
        </footer>
      </div>
    </div>
  );
};

export default Home;
